import { useLoaderData, useNavigate } from "react-router-dom"
import SideDrawer from "../SideDrawer/SideDrawer"
import PrivateRoutes from "../../routes/PrivateRoutes"
import { useEffect } from "react";


export const PowerBiReports = () => {
  const options = useLoaderData();
  const navigate = useNavigate();

  useEffect(() => {
    const onBack = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", onBack);
    return () => window.removeEventListener("popstate", onBack);
  }, [navigate]);

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <SideDrawer options={options.filter(opt => opt.id !== 'kpi')} />
      <div style={{ flex: 1, marginLeft: '75px' }}>
        <PrivateRoutes />
      </div>
    </div>
  )
}